/* Packaging Store */

import {
  createPackaging,
  createPackage,
  fetchCompletePackaging,
  fetchSalesOrderLineItems,
  fetchPackageContents,
  fetchPackageItemContent,
  deletePackage,
  deleteContents,
  createPackageItem,
  deletePackageItem,
  updatePackageItem,
  createPackagingPallet,
  updatePackage,
  updateSalesOrderStatus
} from '@/api'
import {fetchPackagingPallets} from "../../api";

const state = {
  packagingId: null,
  allPallets: [],
  // pallets: [],
  packages: [],
  lineItems: []
}

const actions = {
  createPackaging (context, sono) {
    return createPackaging(sono)
  },
  createPackage (context, payload) {
    return createPackage(payload)
  },
  createPackageItem (context, payload) {
    const packageId = payload['packageId']
    const item = payload['item']
    const quantity = payload['quantity']
    return createPackageItem(packageId, item, quantity)
  },
  fetchCompletePackaging (context, sono) {
    return fetchCompletePackaging(sono).then(response => {
      context.commit('setCompletePackaging', response.data)
    })
  },
  fetchSalesOrderLineItems (context, salesOrderNumber) {
    return fetchSalesOrderLineItems(salesOrderNumber).then(response => {
      context.commit('setLineItems', response.data)
    })
  },
  fetchPackageContents (context, packageId) {
    return fetchPackageContents(packageId)
  },
  fetchPackageItemContent (context, contentId) {
    return fetchPackageItemContent(contentId)
  },
  deletePackage (context, packageId) {
    return deletePackage(packageId)
  },
  deletePackageItem (context, contentId) {
    return deletePackageItem(contentId)
  },
  updatePackage (context, payload) {

    const packageId = payload['packageId']
    delete payload['packageId']

    return updatePackage(packageId, payload)
  },
  updatePackageItem (context, payload) {
    const contentId = payload['contentId']
    delete payload['contentId']
    return updatePackageItem(contentId, payload)
  },
  deleteContents (context, contentId) {
    return deleteContents(contentId)
  },
  createPackagingPallet (context, packagingId) {
    return createPackagingPallet(packagingId)
  },
  fetchAllPackagingPallets (context, packagingId) {
    return fetchPackagingPallets(packagingId).then(response => {
      context.commit('setAllPallets', response.data)
    })
  },
  resetCompletePackaging (context) {
    context.commit('setCompletePackaging', {
      packagingId: null,
      pallets: [],
      packages: []
    })
  },
  completeSalesOrderPackaging (context, sono) {
    return updateSalesOrderStatus({salesOrderNumber: sono, status: 'SHIPPING'})
  },
  resetLineItems (context) {
    return context.commit('setLineItems', [])
  },
  resetAllPallets (context) {
    context.commit('setAllPallets', [])
  }
}

const mutations = {
  setCompletePackaging (state, payload) {
    state.packagingId = payload.packagingId
    // state.pallets = payload.pallets
    state.packages = payload.packages
  },
  setLineItems (state, payload) {
    state.lineItems = payload
  },
  setAllPallets (state, payload) {
    state.allPallets = payload
  }
}

const getters = {
  getCompletePackaging (state) {
    return state
  },
  getPackages (state) {
    return state.packages
  },
  // getPallets (state) {
  //   return state.pallets
  // },
  getAllPallets (state) {

    // A placeholder for pallets.
    const pallets = [{text: 'Select Pallet', value: null}]

    for(let p of state.allPallets) {
      pallets.push({
        text: p.palletId,
        value: p.palletId
      })
    }

    return pallets

  },
  getLineItemsSelect (state) {
    const items = []
    // If there are no items yet, return an empty array.
    if (state.lineItems.length === 0) {
      return items
    }

    for (let i = 0; i < state.lineItems.items.length; i++) {
      let item = state.lineItems.items[i]
      items.push({
        text: item.item,
        value: item.item
      })
    }
    return items
  },
  getLineItemsQuantities (state) {

    // The items to ignore.
    const ignoreItems = [
        'FREE-SHIP',
        'CC_APPROVAL',
        'SHIP',
        'FRT'
    ]

    const items = {}
    for (let item of state.lineItems.items) {

      // Get the item code.
      const itemCode = item.item

      // Ignore bogus items.
      if (ignoreItems.includes(itemCode)) {
        continue
      }

      // Don't overwrite keys.
      if(!(itemCode in items)) {
        items[itemCode] = 0
      }

      // Accumulate a total per item.
      items[itemCode] += item['openQuantity']

    }

    return items

  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
